import { Badge, Icon } from 'components';
import React, { ReactNode } from 'react';

interface IBadgeParent {
  children: ReactNode;
  countNode: ReactNode;
}

export const BadgeParent = ({ children, countNode }: IBadgeParent) => {
  const getUnreadBadge = () => {
    if (typeof countNode === 'boolean') {
      return {
        showError: true,
        count: <Icon type="exclamation" color="errorColor" width={22} />,
      };
    }

    return { showError: false, count: countNode };
  };

  const { showError, count } = getUnreadBadge();

  return (
    <Badge
      color="danger"
      size="small"
      count={count}
      overflowCount={9}
      style={{
        lineHeight: 'normal',
        top: showError ? -10 : undefined,
        right: showError ? -10 : undefined,
      }}
    >
      {children}
    </Badge>
  );
};
